// Разделы списка полей конструктора — как вкладки над списком полей в OLAP iiko.
// Поле, которого нет в карте, попадает в «Прочее» — так новое поле движка не потеряется.

export const SECTIONS = [
	{ key: 'time', fields: ['date', 'week', 'month', 'year', 'weekday', 'hour', 'quarter_hour', 'hour_open', 'quarter_hour_open'] },
	{ key: 'order', fields: ['order_type', 'order_type_sub', 'source', 'cheque', 'hall', 'table', 'guests', 'shift', 'preorder', 'with_discount', 'promo_code'] },
	{ key: 'staff', fields: ['waiter', 'cashier', 'opened_by', 'operator', 'courier'] },
	{ key: 'guests', fields: ['client', 'organization', 'region', 'district'] },
	{ key: 'products', fields: ['product', 'category', 'menu'] },
	{ key: 'payments', fields: ['payment_type', 'payment_category'] },
	{ key: 'point', fields: ['point'] },
]

export function sectionOf(field) {
	const section = SECTIONS.find(item => item.fields.includes(field))
	return section ? section.key : 'other'
}

// Показатели, которые можно показывать долей от итога: суммы и количества складываются.
// Проценты и средние — нет, их доля бессмысленна
export const NON_ADDITIVE = ['margin_percent', 'food_cost_percent', 'service_percent', 'avg_cheque', 'avg_guest', 'avg_price', 'avg_cost', 'min_cheque', 'min_paid_cheque', 'max_cheque']

// Сохранённые до конструктора с перетаскиванием отчёты держали фильтры отдельными списками
export const LEGACY_FILTERS = {
	point_ids: 'point',
	order_type_ids: 'order_type',
	order_type_sub_ids: 'order_type_sub',
	source_ids: 'source',
	category_ids: 'category',
	product_ids: 'product',
	payment_type_ids: 'payment_type',
}

// id перетаскиваемых элементов: «field|dim|hall», «chip|rows|hall», цели — «zone|rows», «slot|rows|2»
export const id = (...parts) => parts.join('|')
export const parseId = (value) => String(value || '').split('|')
